import { Button } from "components";
import s from "components/UI/Button/FormButton.module.scss";
import HotelAdminsDetail from "../HotelAdminsDetails";

export default function DetailModal({
    hotel, closeModal
}) {
    return (
        <>
            <HotelAdminsDetail hotel={hotel} />
            <div className={"closeButtonContainer"}>
                <Button
                    className={s.defaultBtn}
                    onClick={closeModal}
                >
                    Cerrar
                </Button>
            </div>
        </>
    );
}